import ConnexPayService, { IConnexPayConfiguration, IDataType, IVerifyCardResponse } from "./ConnexPayService";
type ConnexPayType = 'sys_loaded' | 'error' | 'validation_error' | 'success'
type ConnexPayDataType = IDataType | IVerifyCardResponse

export default class ConnexPayPayment {
    private connexPayService: ConnexPayService
    constructor(
        private form: JQuery<HTMLFormElement>,
        private submitButton: JQuery<HTMLButtonElement>,
        private configuration: IConnexPayConfiguration) {
        /*
           Instantiate the ConnexPay's SDK by calling its create function. It takes in elementID
           which represents the container's ID and some options. 
          */
        this.connexPayService = new ConnexPayService()
        form.find('.connexpay-form-container').append("<img src='/images/flightsearch/loading.gif' class='loading-bar' />");
        form.find('.connexpay').hide();
        window.ConnexPay.create("#connexpay-element", {
            /*
              * callback - SDK calls this function once the payment call finishes execution.
              * @param type - This represents whether the payment has succeeded or not. 
              * The value can be one of error, success, warning, sys_error, sys_warning, validation_error
              * @param data - Object representing failure or success.
              * @param message -  message string
            */
            callback: this._handleCallBack,
            modal: false, // A generic success confirmation, payment failure, or validation error message will be presented if modal is set to true. It's recommended to use the callback method instead for a more informative response.
            payload: {
                "PublicKey": this.configuration.publicKey, // Unique key provided by ConnexPay for each client and environment.
                /*
                  TransactionType must either be sale or verify. Empty value currently defaults to sale, but will be changed to post an error in future.
                  Sale - the payment is completed using the card inforation. 
                  Verify - verifies card validity and returns ID to be used for Create Sale API. 
                  **! Currently, Verify does not work with ApplePay !**
                */
                "TransactionType": "verify",
                "Description": "", // Description is only used for Hosted Payment Page and may be left empty.
                /*
                  TenderTypeOptions
                  Set to one or more - Credit, ApplePay, GooglePay. If ApplePay and/or GooglePay are being included, Credit must also be included.
                */
                "TenderTypeOptions": [
                    "Credit",
                ],
                "Expiration": this.configuration.expiration, // Expiration has no practical bearing and any future date may be used.
                "sale": {
                    "DeviceGuid": this.configuration.deviceGuid, // Device Guid is a Required field that represents the CXP ID assigned to your merchant API configuration.
                    "Amount": this.configuration.amount, // Amount is a Required field representing the payment amount. Provide this value from your shopping cart, checkout, or some other session variable.
                    /*
                       Label IDs are an Optional array of strings that may be used to associate a sale to a specific label(s) within the ConnexPay Bridge UI.
                       If a sale is tied to an incorrect Label, it will not filter or display correctly in Bridge's Search Grid.
                       Please contact your Customer Care Consultant for a list of valid Label IDs before use.
                    */
                    "LabelIds": [],
                    "RiskProcessingOnly": false,
                    "StatementDescription": "", // US Merchants only: Allows a client to customize the merchant name that appears on the cardholder statement.
                    "OrderNumber": this.configuration.bookingid, // Order Number is an Optional field that may be included from your system as an identifier of the sale. 
                    "CustomerID": "", // CustomerID is an Optional field that may be included from your system as an identifier of the sale.
                    /*
                    "RequestIp": "127.0.0.1", // RequestIP is Optional. The field may be included, but requires a valid IP value.                            
                     */
                    "ConnexPayTransaction": {
                        // ConnexPayTransaction is a Required object signifying the number of outbound payments being made to suppliers.
                        "ExpectedPayments": 1
                    },
                    "IncludeRiskAnalysis": false, // IncludeRiskAnalysis is Optional.
                    /*
                      Riskdata is a Required object; the individual fields are recommended but Optional.
                      If the Transaction Type is "Verify", Risk Data is ignored in the SDK and instead can be submitted when you Create the Sale.
                    */
                    "RiskData": {
                        /*""Name": "",
                        "Email": "",
                        BillingPhoneNumber":"",
                        "BillingAddress1":"",
                        "BillingAddress2":"",
                        "BillingCity":"",
                        "BillingState":"",
                        "BillingPostalCode":"",
                        "BillingCountryCode":"",
                        "ProductType": "",
                        "ProductDesc": "",
                        "ProductItem": "",
                        "ProductQuantity": 1,
                        "ProductPrice": 100,
                        "OrderNumber": "",
                        "SellerID": ""*/
                    }
                    // Customer information is Optional. Recommended to use First/LastName as it can help in reporting and reviewing in Bridge.
                    //"Customer": {
                    //"FirstName": "",
                    //"LastName": "",
                    /*"BusinessName": "", // Ten digit phone
                    "Phone": "",
                    "City": "", // Two letters state. For example NY
                    "State": "",
                    "Country": "",
                    "Email": "",
                    "Address1": "",
                    "Address2": "",
                    "Zip": "",
                    "DateOfBirth": "YYY-MM-DD",
                    "DriverLicenseNumber": "", // Two letters state. For example, NY            
                    "DriverLicenseState": "",
                    "SSN4": "1210"*/
                    //}
                }
            },
            elements: {
                // fields create a map of form elements to their id
                fields: {
                    submit: "#connexpay-submit-button",
                    //googlePay: "#custom-googlepay-button",
                    //applePay: "custom-applepay-button",
                    name: "#custom-cardholder",
                    email: "#custom-receipt-email"
                },
                css: {
                    // CSS applied to the container that holds ConnexPay's form elements
                    container: {
                        'display': 'flex',
                        'flex-direction': 'column',
                        'gap': '16px',
                        'min-height': '250px',
                        'border': '0px solid #91b7de',
                        'margin-top': '15px',
                        'font-family': 'Roboto, sans-serif'
                    },
                    // CSS applied to each input field. This is for both the label and the input fields
                    input: {
                        'font-size': '15px',
                        'font-weight': '600',
                        'width': '100%',
                        'height': '35px',
                    },
                    // CSS applied to the input field only
                    inputInside: {
                        'background-color': '#fdfdfd',
                        'border': '1px solid #b3cde0',
                        'border-radius': '.15rem',
                        'font-size': '1rem',
                        'height': '46px',
                        'line-height': '1.5',
                        'outline': '0',
                        'padding': '.6rem .8rem',
                    },
                    // CSS applied to the label field only
                    label: {
                        'font-family': 'Roboto, sans-serif',
                        'font-weight': '700',
                        'font-size': '100%',
                        'line-height': '0',
                        'color': '#000',
                        'left': '0px'
                    },
                    // CSS applied to the card logo displayed on the right side of the credit card input field
                    logo: {
                        'zoom': '0',
                        'right': '10px'
                    }
                }
            }
        });

    }

    public setBrowserInfo(): void {
        const redirectURL = this.form.find('input[name="redirectURL"]').val() as string;
        const browserInfo = this.connexPayService.getBrowserInfo(this.configuration.acceptHeader,redirectURL)
        const browserInfoInput = this.form.find('input[name="threeDSBrowserInfo"]');
        browserInfoInput.val(JSON.stringify(browserInfo));
    }
    private getVerifyGuid() {
        return this.form.find('input[name="paymentResult"]');
    }
    private getVerifyPaymentMethod() {
        return this.form.find('input[name="paymentMethod"]');
    }
    private getPaymentMethodCode(paymentType): string {
        switch (paymentType) {
            case 'Visa':
                return 'VSA';
            case 'Mastercard':
                return 'MC';
            case 'Amex':
                return 'AMEX';
            default:
                return '';
        }
    }
    public _handleCallBack = (type: ConnexPayType, data: ConnexPayDataType, message: string) => {
        /*
            TODO: It is recommend that you implement a method in your app to react to the payment success or failure using the callback method. 
            Example: Upon payment submission, use the response type, data, and message object to inform a redirect for success and failure.
        */
        try {

            const container = this.form.find('.connexpay-validation-container .validation-error')
            if (type === 'sys_loaded') {
                this.form.find('.connexpay-form-container').find('.loading-bar').remove();
                this.form.find('.connexpay').show();
            }

            if (type === 'error' && (data as IDataType).type === 'validation') {
                const validateData = data as IDataType
                container.text(validateData.msg)
                throw new Error(validateData.msg);
            } else if (type === 'error' && (data as IDataType).type === 'error') {
                const validateData = data as IDataType
                container.text(validateData.msg)
                throw new Error(validateData.msg);            
            }
            else if (type === 'success') {
                const sccessData = data as IVerifyCardResponse
                this.enableSubmitButton = false;
                this.form.find('input[name="paymentResult"]').val(JSON.stringify(sccessData.verify.card))
                this.form.find('input[name="paymentMethod"]').val(this.getPaymentMethodCode(sccessData.verify.card.cardType))
                this.form.trigger('submit')
            }
        } catch (error) {
            this.enableSubmitButton = true;
            // tslint:disable-next-line:no-console
            console.error(error);
        }
    }

    private set enableSubmitButton(isEnable: boolean) {
        this.submitButton.prop('disabled', !isEnable);
    }
    public submitForm(event: JQuery.SubmitEvent) {

        if (!this.getVerifyGuid().val()) {
            return;
        }
        if (!this.getVerifyPaymentMethod().val() && this.getVerifyPaymentMethod().val() !== '') {
            return;
        }
        this.setBrowserInfo()

    }

}

